import { TrackActionsServiceBase } from './track-actions-service-base';

class TrackActionsService extends TrackActionsServiceBase {
  public onContinueToPaypal() {
    return this.ga4Track('Continue to PayPal');
  }

  public billingInfoUpgradeSuccess() {
    return this.ga4Track('Billing info page - successful upgrade');
  }

  public billingInfoUpgradeFormValidationFailed() {
    return this.ga4Track('Billing info page - form validation failed');
  }

  public billingInfoUpgradePaymentMethodFailed() {
    return this.ga4Track('Billing info page - payment method validation failed');
  }
}

export const trackActionsService = new TrackActionsService();
